import React from 'react';

/**
 * Service date template
 */
export const ServiceDateTemplate: React.FC<{ dateString?: string | null }> = ({ dateString }) => {
  return <span>{dateString ? new Date(dateString).toLocaleDateString() : '-'}</span>;
};

export default ServiceDateTemplate;
